import EscPosEncoder from '@/lib/print/EscPosEncoder';
import { IEscposPrinterSettings } from '@/lib/print/printer-settings';
import { loadImage } from '@/utils';
import { Globals } from '@/modules/Globals';

/**
 * Rendered ticket-logo bytes, keyed `${logoPath}|${codepage}|${model}` —
 * the cached buffer bakes in `ESC t <codepage>` and printer-type bytes, so a
 * codepage/model change must re-render. SINGLE-FLIGHT promise map:
 * concurrent doc builds awaiting the same key coalesce into one image load,
 * and there is no check-then-use window to tear under concurrent branches
 * (WP2b). A failed load DELETES the entry so the next print retries.
 */
const logoBytesCache = new Map<string, Promise<Uint8Array | null>>();

export function getLogoBytes(
  logoPath: string,
  escpos: IEscposPrinterSettings
): Promise<Uint8Array | null> {
  const key = `${logoPath}|${escpos.codepage}|${escpos.model}`;
  const existing = logoBytesCache.get(key);
  if (existing) return existing;

  const promise = (async () => {
    const tempEnc = new EscPosEncoder({ model: escpos.model });
    tempEnc.codepage(escpos.codepage);
    const path = `${Globals.uploadsPath}/${logoPath}`;
    const img = await loadImage(path);
    tempEnc.image(img, 160, 160);
    return tempEnc.encode();
  })().catch((e): null => {
    console.error('Error cargando logo de ticket', e);
    logoBytesCache.delete(key);
    return null;
  });

  logoBytesCache.set(key, promise);
  return promise;
}

/** Test hook: drops every cached entry (the map is module state). */
export function resetLogoBytesCache(): void {
  logoBytesCache.clear();
}
